import styled from 'styled-components';
import { StyledBannerImageProps } from './BannerImage.types';

export const StyledBannerImage = styled.div<StyledBannerImageProps>`
  .banner-image__mobile-tablet {
    display: flex;
  }

  ${(props) => props.customStyle}
`;
